import React, { useEffect } from 'react';

import { useGraphQLSuspenseQuery } from '@betterment/graphql';
import { useNavigate } from 'react-router-dom';

import { getInitialFormValues } from './data';
import FlowController from './FlowController';
import { CreateBillingPlanFlowDocument } from './graphql/query.createBillingPlanFlow.generated';
import { useBillingPlanStorage } from './hooks/useBillingPlansStorage';

import urlBuilder from '../../../Shared/url-builder';
import { FullPageLoader } from '../../FullPageLoader';

const CreateBillingPlanFlow: React.FC = () => {
  const navigate = useNavigate();

  const { data } = useGraphQLSuspenseQuery(CreateBillingPlanFlowDocument);
  const { platformFee, feeConfiguration, billingFrequency } = data.firm;

  const { values: sessionValues } = useBillingPlanStorage(
    // @ts-expect-error TS2345 violates strict null checks
    getInitialFormValues(platformFee, feeConfiguration, billingFrequency)
  );

  useEffect(() => {
    if (!sessionValues) {
      // If sessionValues are not set, redirect to the home page
      void navigate('/client_billing/billing_plans');
    }
  }, [sessionValues, navigate]);

  if (!sessionValues) {
    return null;
  }

  return (
    <FlowController url={`${urlBuilder.getCreateBillingPlanFlowRoute.absolutePath}/*`} initialValues={sessionValues} />
  );
};

export const CreateBillingPlanFlowPage: React.FC = () => {
  return (
    <React.Suspense fallback={<FullPageLoader />}>
      <CreateBillingPlanFlow />
    </React.Suspense>
  );
};
